<template>
    <div>
        <Head ><title>Orders -Details</title></Head>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
            <span class="text-indigo-400 font-medium">/</span> Details
        </h1>
        <trashed-message v-if="order.deleted_at" class="mb-6" @restore="restore"> This Order has been
            deleted.
        </trashed-message>
        <div class="flex gap-6">

            <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
                <form @submit.prevent="update">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <select-input v-model="form.customer" :error="form.errors.customer"
                                      class="pb-8 pr-6 w-full lg:w-1/2" label="Customer">
                            <option :selected="true" v-bind:value="form.customer">{{ order.customer.name }}</option>
                            <option v-for="customer in customers" v-bind:value="form.customer">
                                {{ customer.name }}
                            </option>
                        </select-input>
                        <select-input v-model="form.project" :error="form.errors.project"
                                      class="pb-8 pr-6 w-full lg:w-1/2"
                                      label="Project">
                            <option :selected="true" v-bind:value="form.project">{{ order.project.name }}</option>
                            <option v-for="project in projects" v-bind:value="form.project">
                                {{ project.name }}
                            </option>
                        </select-input>

                        <text-input v-model="form.reference" :error="form.errors.reference"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    readonly="readonly"
                                    label="Payment Reference"/>
                        <text-input v-model="form.amount" :error="form.errors.amount" class="pb-8 pr-6 w-full lg:w-1/2"
                                    label="Amount Paid" readonly/>

                        <select-input v-model="form.payment_method" v-bind:value="form.payment_method"
                                      :error="form.errors.payment_method" class="pb-8 pr-6 w-full lg:w-1/2"
                                      label="Payment Method">
                            <option value="mpesa">Mpesa</option>
                            <option value="paypal">PayPal</option>


                        </select-input>

                        <select-input v-model="form.status"
                                      v-bind:value="form.status" :error="form.errors.status"
                                      class="pb-8 pr-6 w-full lg:w-1/2" label="Order Status">

                            <option value="Pending">Pending</option>
                            <option value="Failed">Failed</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Completed">Completed</option>

                        </select-input>


                        <textarea-input v-model="form.description" :error="form.errors.description"
                                        class="pb-8 pr-6 w-full lg:w-1/2" label="Description"/>
                    </div>
                    <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                        <button v-if="!order.deleted_at" class="text-red-600 hover:underline" tabindex="-1"
                                type="button"
                                @click="destroy">Delete Order
                        </button>
                        <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Order
                        </loading-button>
                    </div>
                </form>
            </div>
            <div>
                <div
                    class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">

                    <h5 class="mb-2 text-1xl font-bold tracking-tight text-gray-900 dark:text-white">
                        {{ order.customer_name }} Info
                    </h5>
                    <div class="flex items-center space-x-4">
                        <ul>
                            <li class="mb-3 mt-2 p-2">Phone : {{ order.customer.name }}</li>
                            <li class="mb-3 mt-2 p-2">Email : {{ order.customer.email }}</li>
                            <li class="mb-3 mt-2 p-2">Total Orders : {{ order.customer_orders_count }}</li>
                        </ul>


                    </div>

                    <Link
                        class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        :href="`/customers/${order.customer.id}/edit`"
                        tabindex="-1">
                        More Info
                        <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </Link>
                </div>
                <div v-if="order.payment"
                     class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 mt-2">
                    <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Payment
                        Details</h5>


                    <div class="flex items-center space-x-4">
                        <ul>
                            <li class="mb-3 mt-2 p-2">Payment Date : {{ order.payment_date }}</li>
                            <li class="mb-3 mt-2 p-2">Settled At : {{ order.payment_settlement_date }}</li>
                            <li class="mb-3 mt-2 p-2">More Info : {{ order.payment_reference }}</li>
                        </ul>


                    </div>

                    <Link
                        class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        :href="`/customers/${order.customer.id}/edit`"
                        tabindex="-1">
                        Details
                        <svg aria-hidden="true" class="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </Link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from "@/Shared/TextareaInput";

export default {
    components: {
        TextareaInput,
        Head,
        Icon,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        order: Object,
        customers: Object,
        projects: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                id: this.order.id,
                customer_id: this.order.customer.id,
                project_id: this.order.project.id,
                reference: this.order.reference,
                payment_method: this.order.payment_method,
                payment_status: this.order.payment_status,
                status: this.order.status,
                amount: this.order.amount,
                description: this.order.description,
            }),
        }
    },
    methods: {
        update() {
            this.form.put(`/order/${this.order.id}`)
        },
        destroy() {
            if (confirm('Are you sure to Delete this Order?')) {
                this.$inertia.delete(`/order/${this.order.id}`)
            }
        },
    },
}
</script>
